<template>
  <div>
    <header>
      <div class="header">
        <div class="header-container">
          <a href="https://www.lbbd.gov.uk"
            ><img src="logo.svg" alt="Logo" class="logo"
          /></a>
          <div class="menu-flex" v-if="view !== 'uat'">
            <div class="menu-toggle" @click="toggleMenu">Menu</div>
            <nav class="menu" :class="{ 'menu-visible': menuVisible }">
              <a href="https://www.lbbd.gov.uk/"><b>Services</b></a>
              <a href="https://www.lbbd.gov.uk/make-payment"><b>Pay</b></a>
              <a href="https://www.lbbd.gov.uk/report-problem"><b>Report</b></a>
              <a href="https://www.lbbd.gov.uk/apply-or-request-council-service"
                ><b>Apply</b></a
              >
              <a href="https://mybd.lbbd.gov.uk/"><b>My B&amp;D</b></a>
            </nav>
          </div>
        </div>
        <nav aria-labelledby="Breadcrumbs">
          <h2 class="breadcrumbs-title">Breadcrumbs</h2>
          <ol class="breadcrumbs">
            <li class="breadcrumbs">
              <a class="breadcrumbs-link" href="https://lbbd.gov.uk">Home</a>
            </li>
            <li class="breadcrumbs">/ Answers</li>
            <li class="breadcrumbs restart-uat" v-if="view === 'uat'">
              <button @click="startAgain" class="restart-btn">
                Start Again
              </button>
            </li>
          </ol>
        </nav>
      </div>
    </header>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useAppStore } from '../store/appStore';

export default defineComponent({
  name: 'Header',
  setup() {
    const menuVisible = ref(false);
    const appStore = useAppStore();
    const view = appStore.view;
    const toggleMenu = () => {
      const mediaQuery = window.matchMedia('(max-width: 420px)');
      if (mediaQuery.matches) {
        menuVisible.value = !menuVisible.value;
      }
    };
    const startAgain = () => {
      window.location.reload();
    };
    return { toggleMenu, menuVisible, view, startAgain };
  }
});
</script>

<style scoped>
.restart-uat {
  justify-self: flex-end;
  justify-items: flex-end;
  align-content: flex-end;
  margin-left: auto;
}

.restart-btn {
  background: none;
  border: none;
  font-size: inherit;
  cursor: pointer;
  padding: 0;
}
.breadcrumbs {
  display: flex;
  gap: 5px;
  margin-bottom: 8px;
}

.breadcrumbs-title {
  display: none;
}

.breadcrumbs-link {
  border-bottom: 2px solid #320a4b;
}

ol {
  font-size: large;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.feedback {
  text-align: center;
  padding: 5px 2px;
  background-color: #320a4b;
  color: white;

  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
}

.feedback-text {
  text-align: left;
}

.feedback a {
  color: white;
  text-decoration: underline;
}

.beta {
  background-color: white;
  color: #320a4b;
  padding: 0.1rem 0.2rem 0.1rem 0.2rem;
  font-weight: 700;
  font-size: 1.2rem;
  margin-left: 20px;
  vertical-align: middle;
}

.header-container {
  padding: 5px 2px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
}

.menu-toggle {
  display: none;
  cursor: pointer;
  font-weight: bold;
}

.menu-toggle::after {
  content: ' ▼';
  font-size: 0.9rem;
  line-height: 3;
  position: relative;
  right: 0px;
  top: 0;
}

.menu {
  display: flex;
  gap: 13px;
  background-color: white;
  padding: 3px;
}

@media (max-width: 600px) {
  .menu {
    opacity: 0;
    height: 0;
    overflow: hidden;
    transition: height 0.4s ease;
    position: absolute;
    right: 5px;
    top: 30px;
    gap: 16px;
    z-index: 1;
    flex-direction: column;
    padding-top: 16px;
    padding-left: 16px;
  }

  .menu-flex {
    position: relative;
  }

  .menu-toggle {
    display: block;
    right: 12px;
  }

  .menu-visible {
    opacity: 100;
    height: auto;
  }
}

.logo {
  height: 60px;
  width: auto;
}

a {
  text-decoration: none;
  color: black;
}
</style>
